import { createContext } from 'react';

interface CardModeContextValues {
  /**
   * Dictates which context the card component is rendered in. `clickable` means the fields are clickable, `read-only` means the fields cannot be clicked, `edit` means the fields can be clicked to edit them.
   */
  mode: 'clickable' | 'read-only' | 'edit' | undefined;
}

const initialContext: CardModeContextValues = {
  mode: undefined,
};

const cardModeContext = createContext<CardModeContextValues>(initialContext);

export { cardModeContext };
